/**
 * Canonical company work status values for overall deal / 280G workflow.
 * Keep in sync with: `api/PctIq.Services/FirmCompanyService.NormalizeWorkStatus`,
 * `server/store.js` (ALLOWED_WORK_STATUS), and DB check constraints if any.
 */
export const COMPANY_WORK_STATUS_VALUES = ['intake', 'in_progress', 'review', 'complete', 'on_hold'] as const;

export type CompanyWorkStatus = (typeof COMPANY_WORK_STATUS_VALUES)[number];

const WORK_STATUS_LABELS: Record<CompanyWorkStatus, string> = {
  intake: 'Intake / setup',
  in_progress: 'In progress',
  review: 'In review',
  complete: 'Complete',
  on_hold: 'On hold',
};

export const WORK_STATUS_OPTIONS = COMPANY_WORK_STATUS_VALUES.map((value) => ({
  value,
  label: WORK_STATUS_LABELS[value],
}));

export function isCompanyWorkStatus(value: string): value is CompanyWorkStatus {
  return (COMPANY_WORK_STATUS_VALUES as readonly string[]).includes(value);
}
